import type { DBGHubPayload } from "./dbghub";

export const createBlankPayload = (): DBGHubPayload => {
    const blank: DBGHubPayload = {
        "customerName": "",
        "customerType": "HO",
        "portfolioNetValue": {
            "dbgValue": 0,
            "dbgValueCurrentQuarter": 0,
            "dbgNetOpportunity": 0,
            "dbgTrend":  [
                {
                    "name": "Arrotex",
                    "data": [{value: 0, period: ""}, {value: 0, period: ""}, {value: 0, period: ""}, {value: 0, period: ""}]
                },
                {
                    "name": "VidaCorp",
                    "data": [{value: 0, period: ""}, {value: 0, period: ""}, {value: 0, period: ""}, {value: 0, period: ""}]
                },
                {
                    "name": "PharmaPrograms",
                    "data": [{value: 0, period: ""}, {value: 0, period: ""}, {value: 0, period: ""}, {value: 0, period: ""}]
                }
            ]
        },
        "arrotex": {
            "value": 0,
            "valueCurrentQuarter": 0,
            "terms": 0,
            "signOnBonus": 0,
            "rebates": 0,
            "marketingSupport": 0,
            "bonusStock": 0,
            "opportunity": 0,
            "portfolioValues": [
                {
                    "portfolioName": "Generics",
                    "earnedValue": 0,
                    "opportunity": 0,
                    "compliance": [
                        { "label": "Loyalty", "value": 0 },
                        { "label": "Substitution", "value": 0 }
                    ],
                    "opportunityProducts": [],
                    "focusProducts": []
                },
                {
                    "portfolioName": "Specialty Brands",
                    "earnedValue": 0,
                    "opportunity": 0,
                    "compliance": [
                        { "label": "Franchise Share", "value": 0 },
                        { "label": "Substitution", "value": 0 }
                    ],
                    "opportunityProducts": [],
                    "focusProducts": []
                },
                {
                    "portfolioName": "Biologics",
                    "earnedValue": 0,
                    "opportunity": 0,
                    "compliance": [
                        { "label": "Loyalty", "value": 0 },
                        { "label": "Substitution", "value": 0 }
                    ],
                    "opportunityProducts": [],
                    "focusProducts": []
                }
            ]
        },
        "vidacorp": {
            "value": 0,
            "valueCurrentQuarter": 0,
            "terms": 0,
            "signOnBonus": 0,
            "rebates": 0,
            "marketingSupport": 0,
            "bonusStock": 0,
            "opportunity": 0,
            "portfolioValues": [
                {
                    "portfolioName": "Apohealth",
                    "earnedValue": 0,
                    "opportunity": 0,
                    "compliance": [
                        { "label": "Loyalty", "value": 0 },
                        { "label": "Substitution", "value": 0 }
                    ],
                    "opportunityProducts": [],
                    "focusProducts": []
                },
                {
                    "portfolioName": "Chemists' Own",
                    "earnedValue": 0,
                    "opportunity": 0,
                    "compliance": [
                        { "label": "Loyalty", "value": 0 },
                        { "label": "Substitution", "value": 0 }
                    ],
                    "opportunityProducts": [],
                    "focusProducts": []
                },
                {
                    "portfolioName": "Health & Wellness",
                    "earnedValue": 0,
                    "opportunity": 0,
                    "compliance": [
                        { "label": "Loyalty", "value": 0 },
                        { "label": "Substitution", "value": 0 }
                    ],
                    "opportunityProducts": [],
                    "focusProducts": []
                }
            ]
        },
        "pharmaprograms": [
            {
                "brandName": 'Amgevita',
                "claimsEarnedValue": 0,
                "claimsEarnedValueCurrentQuarter": 0,
                "claimsOpportunityValue": 0,
                "scripts": 0,
                "claims": 0,
                "scriptsVersusPreviousQuarter": 0,
                "claimsVersusPreviousQuarter": 0,
                "scriptsAndClaimsSeries": []
            },
            {
                "brandName": 'Hadlima',
                "claimsEarnedValue": 0,
                "claimsEarnedValueCurrentQuarter": 0,
                "claimsOpportunityValue": 0,
                "scripts": 0,
                "claims": 0,
                "scriptsVersusPreviousQuarter": 0,
                "claimsVersusPreviousQuarter": 0,
                "scriptsAndClaimsSeries": []
            },
            {
                "brandName": 'Mytolac',
                "claimsEarnedValue": 0,
                "claimsEarnedValueCurrentQuarter": 0,
                "claimsOpportunityValue": 0,
                "scripts": 0,
                "claims": 0,
                "scriptsVersusPreviousQuarter": 0,
                "claimsVersusPreviousQuarter": 0,
                "scriptsAndClaimsSeries": []
            },
            {
                "brandName": 'SteQeyma',
                "claimsEarnedValue": 0,
                "claimsEarnedValueCurrentQuarter": 0,
                "claimsOpportunityValue": 0,
                "scripts": 0,
                "claims": 0,
                "scriptsVersusPreviousQuarter": 0,
                "claimsVersusPreviousQuarter": 0,
                "scriptsAndClaimsSeries": []
            },
            {
                "brandName": 'Prolia',
                "claimsEarnedValue": 0,
                "claimsEarnedValueCurrentQuarter": 0,
                "claimsOpportunityValue": 0,
                "scripts": 0,
                "claims": 0,
                "scriptsVersusPreviousQuarter": 0,
                "claimsVersusPreviousQuarter": 0,
                "scriptsAndClaimsSeries": []
            }
        ]
    };

    return JSON.parse(JSON.stringify(blank)) as DBGHubPayload;
}
